import { Component, HostListener, inject } from '@angular/core';
import {VwuiModalConfig} from '@bvgo-ict/vwui-angular';
import {ProjectReferencePhoto} from '../../models/project-reference-photo';
import {BlobDownloadService} from '../../services/blob-download.service';
import {ToastrService} from 'ngx-toastr';
import {highestWidthSrcsetSrc, srcsetToHtmlString} from '../../models/photo';

@Component({
    selector: 'app-ligthbox-modal',
    templateUrl: './lightbox-modal.component.html',
    standalone: false
})
export class LightboxModalComponent {
    private blobDownloadService = inject<BlobDownloadService>('BlobDownloadService' as any);
    private toastr = inject(ToastrService);
    private modalConfig = inject<VwuiModalConfig<{
    photos: ProjectReferencePhoto[];
    activeIndex: number;
    projectName: string;
}>>(VwuiModalConfig);

    photos: ProjectReferencePhoto[];
    activeIndex: number;
    projectName: string;

    constructor() {
        const modalConfig = this.modalConfig;

        if (!modalConfig.data?.photos) {
            throw Error('Modal missing photos parameter');
        }

        this.photos = modalConfig.data.photos;
        this.activeIndex = modalConfig.data.activeIndex ?? 0;
        this.projectName = modalConfig.data.projectName;
    }

    get photoSrc() {
        const photo = this.photos[this.activeIndex];

        return photo.srcset ? highestWidthSrcsetSrc(photo.srcset) : photo.originalUrl;
    }

    get photoSrcset() {
        const photo = this.photos[this.activeIndex];

        return photo.srcset ? srcsetToHtmlString(photo.srcset) : undefined;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.code === 'ArrowLeft') {
            this.previous();
        }

        if (event.code === 'ArrowRight') {
            this.next();
        }
    }

    next() {
        this.activeIndex = (this.activeIndex + 1) % this.photos.length;
    }

    previous() {
        if (this.activeIndex <= 0) {
            this.activeIndex = this.photos.length - 1;
        } else {
            this.activeIndex--;
        }
    }

    downloadActivePhoto() {
        const photo = this.photos[this.activeIndex];
        if (photo.originalUrl) {
            const extension = (new URL(photo.originalUrl)).pathname.split('.').pop()!.trim();
            const fileName = `${this.projectName}_${this.activeIndex + 1}.${extension}`;
            this.blobDownloadService.saveBlob(photo.originalUrl, fileName);
        } else {
            console.error(`Photo ${photo.id} could not be downloaded as it has no url`);
            this.toastr.error('De foto kan niet gedownload worden.');
        }

    }
}
